import * as React from 'react';
import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit';

import { IPromoInfoSchema } from '../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';
import { getPromoIcon } from './utils/getPromoIcon';

import * as styles from './styles.css';

interface IPromoItemProps {
  onClick(): void;
  promo: IPromoInfoSchema;
}

export function PromoItem({ promo, onClick }: IPromoItemProps) {
  const { name, promoType, bank, subtitle } = promo;

  return (
    <div className={styles['container']} onClick={onClick} data-testid="PromoItem">
      <div className={styles['icon']}>{getPromoIcon(promoType, bank)}</div>
      <div className={styles['description']}>
        <div className={styles['title']}>
          <ArticleHeading4 as="h4">{name}</ArticleHeading4>
        </div>
        {subtitle && <ArticleParagraph2 color="gray60_100">{subtitle}</ArticleParagraph2>}
      </div>
    </div>
  );
}
